import { userApi, componentApi } from '@/data'
import i18n from '@/locales/i18n'
import { ResponseError } from 'hcosmos-api-data'

import { useToast } from 'vue-toastification'

export function createCreateSystemWithTragarm() {
  return async (serialNumber: string, tragArmModel: string, batchSize: number) => {
    try {
      await userApi.newSystemWithTragarm({
        tragarmSystemInfo: {
          tragArmSerialNumber: serialNumber,
        tragArmModel: tragArmModel,
          batchSize: batchSize
        }
      })
    } catch (e) {
      console.error('Failed to create system:', e)
      throw e
    }
  }
}

export function createDeleteTragArmSystem() {
  return async (systemId: string) => {
    try {
      await componentApi.deleteTragArmSystem({
        id: systemId
      })
    } catch (e) {
      console.error('Failed to delete system:', e)
      throw e
    }
  }
}
